import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/elementor': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M425.6 32H22.4C10 32 0 42 0 54.4V457.6C0 470 10 480 22.4 480H425.6C438 480 448 470 448 457.6V54.4C448 42 438 32 425.6 32M164.3 355.5H124.5V156.5H164.3V355.5zM323.6 355.5H204.1V315.7H323.6V355.5zM323.6 275.9H204.1V236.1H323.6V275.9zM323.6 196.2H204.1V156.4H323.6V196.2z'
      }
    ]
  }
})
